

import React from "react"

export default function Header() {
    return (
        <header>
            <title>アイリス・オデッセイ</title>
            <meta name="description" content="現代ファンタジーADV アイリス オデッセイ Steamにて2025年夏発売予定" />
        </header>
    )
}